/** @format */

import {Box, Typography} from '@mui/material';
import {styled} from '@mui/material/styles';

export const TooltipContentContainer = styled(Box)(({theme}) => ({
  padding: theme.spacing(4),
  background: theme.palette.semantic_light?.surface.background,
  color: theme.palette.semantic_light?.surface.onSurface,
  maxWidth: '400px',
  borderRadius: theme.shape.borderRadius,
  fontSize: '16px',
}));

export const StyledImage = styled('img')(({theme}) => ({
  height: '20px',
  width: '71px',
  marginLeft: theme.spacing(1),
}));

export const StyledTypographyTitle = styled(Typography)(({theme}) => ({
  fontWeight: 400,
  fontSize: '16px',
  marginBottom: theme.spacing(1),
}));

export const StyledTypographyDescription = styled(Typography)({
  fontWeight: 400,
  fontSize: '16px',
});
